import React from 'react';
import { TagOptionRecord } from '../types';

export const nullFn = (): null => null;

export function isEmpty(field: string | number | undefined = ''): boolean {
  if (typeof field === 'number') {
    return false;
  }

  return !field || field.length === 0;
}

export function getOptionProperty<T extends TagOptionRecord>(
  option: T,
  valueField: string | number = 'label',
): React.ReactNode | string {
  if (typeof option === 'string' || typeof option === 'number') {
    return option;
  }

  if (valueField && option[valueField]) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return option[valueField];
  } else {
    return option;
  }
}

export function insertItem<T extends TagOptionRecord>(
  array: Array<T> = [],
  item: T,
): Array<T> {
  return [...array, item];
}

export function filterItems<T extends TagOptionRecord>(
  options: Array<T> = [],
  needle: string,
  valueField = 'id',
): Array<T> {
  return options.filter((item) => {
    if (typeof item === 'string' || typeof item === 'number') {
      return String(item).toLowerCase().includes(needle.toLowerCase());
    }

    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return `${item[valueField]}`.toLowerCase().includes(needle.toLowerCase());
  });
}

export function optionExists<T extends TagOptionRecord>(
  options: Array<T> = [],
  value: string,
  valueField = 'label',
): number {
  return options.findIndex((item) => {
    if (typeof item === 'string' || typeof item === 'number') {
      return String(item).toLowerCase() === value.toLowerCase();
    }

    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return `${item[valueField]}`.toLowerCase() === value.toLowerCase();
  });
}

export function removeItem<T extends TagOptionRecord>(
  array: Array<T> = [],
  item: T,
  keyField = 'id',
  valueField = 'label',
): Array<T> {
  const newArray = array.slice();

  newArray.splice(
    newArray.findIndex((a) => {
      if (typeof a === 'object' && typeof item === 'object') {
        if (keyField in item) {
          return a[keyField] === item[keyField];
        }

        return a[valueField] === item[valueField];
      }

      return a === item;
    }),
    1,
  );

  return newArray;
}

export function isOptionSelected<T extends TagOptionRecord>(
  option: T,
  selectedOptions: Array<T> = [],
  keyField = 'id',
): boolean {
  return selectedOptions.some((opt) => {
    if (typeof opt === 'object' && typeof option === 'object') {
      return opt[keyField] === option[keyField];
    }

    return opt === option;
  });
}
